/**
 * Plain object CustomsUserInformation representation.
 *
 */

/**
 * Type of user
 */
let CustomsUserType = /*#__PURE__*/function (CustomsUserType) {
  CustomsUserType["PRIVATE_PERSON"] = "PRIVATE_PERSON";
  CustomsUserType["COMPANY"] = "COMPANY";
  return CustomsUserType;
}({});

/**
 * Shipment information required to complete a customs invoice
 */

export { CustomsUserType };
//# sourceMappingURL=CustomsUserInformation.js.map
